module.exports = "/img/monitor.5e0bd315.svg";